export default __webpack_public_path__ + "static/50-0152d8479961563201c7bc30d994ddea.png";